import { Heading, Stack, StackProps } from '@chakra-ui/react';
import { Address, Contact } from '@pelicargo/types';
import { isoCountryFallback, isoStateFallback, join } from '@pelicargo/utils';
import { useMemo } from 'react';

import { LabeledValue } from '../LabeledValue';

type Props = StackProps & {
  heading?: string;
  dropOffDate: string;
  address: Address;
  dockHours: string;
  contact: Contact;
  truckingName?: string;
};

export const DropOffSection = ({
  heading = 'Drop-Off',
  dropOffDate,
  address,
  truckingName,
  dockHours,
  contact,
  ...rest
}: Props) => {
  const addressText = useMemo(() => {
    return [
      address?.recipient,
      address?.line_one,
      address?.line_two,
      join([address?.city, isoStateFallback(address?.state), address?.zip_code, isoCountryFallback(address?.country)]),
    ]
      .filter(Boolean)
      .join('\n');
  }, [address]);

  const contactInfo = [contact?.full_name, contact?.phone_number, contact?.email].filter(Boolean).join('\n');

  return (
    <Stack spacing="6" flex="1" {...rest}>
      <Heading variant="h5">{heading}</Heading>

      <Stack direction="row" spacing="6">
        <Stack flex="1">
          <LabeledValue label="Warehouse Address" value={addressText} />
          <LabeledValue label="Dock Hours" value={dockHours} />
          <LabeledValue label="Contact" value={contactInfo} defaultValue="-" />
        </Stack>
        <Stack flex="1">
          <LabeledValue label="Drop-off Date" value={dropOffDate} defaultValue="-" />
          <LabeledValue label="Truck Company" value={truckingName} defaultValue="-" />
        </Stack>
      </Stack>
    </Stack>
  );
};
